import React from 'react';
import T from 'i18n-react';
import MajorText from './MajorText';
import LabeledCheckbox from '../LabeledCheckbox';
import withValidation from './Form/withValidation';
import moment from 'moment';
import MinorText from './MinorText';
import PropTypes from 'prop-types';

const PdfPreview = ({
  values,
  errors,
  handleChange,
  handleBlur,
  onPrevStage,
  data,
  paxData,
  guardianData,
  paxAdult,
  allCountries,
  progressBar,
  handleSubmit,
  paxDisplayName,
}) => {
  const checkboxProps = ({ id, label }) => ({
    id,
    name: id,
    type: 'checkbox',
    value: values[id],
    error: errors[id],
    checked: values[id],
    onChange: handleChange,
    onBlur: handleBlur,
    label: T.translate(label),
  });

  const loaLawyerDocumentData = (data && data.loaLawyerDocumentData) || {};
  const { lawFirm } = loaLawyerDocumentData;
  const {country: lawFirmCountry} = lawFirm || {}
  const country = (lawFirm && allCountries)
    ? allCountries.find( country => country.value === lawFirmCountry)
    : {};

  return (
    <div>
      <div className="container container--pdf">
        <h1 className="container__header">
        {`${T.translate('docPreview')} ${paxDisplayName}`}
        </h1>
        {paxAdult ? (
          <MajorText
            paxData={paxData}
            country={country.label}
            {...loaLawyerDocumentData}
          />
        ) : (
          <MinorText
            guardianData={guardianData}
            paxData={paxData}
            country={country.label}
            {...loaLawyerDocumentData}
          />
        )}
        <p style={{ width: '100%', textAlign: 'left' }}>
          {T.translate('doneAt')}{' '}
          <b>
            <input
              type="text"
              id="signedIn"
              name="signedIn"
              value={values.signedIn}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.signedIn && 'border--error'}
            />{' '}
            {T.translate('onThe')} {moment().format('DD/MM/YYYY')}
          </b>
          <br />
        </p>
        <div className="col" style={{ width: '100%' }}>
          <LabeledCheckbox
            {...checkboxProps({
              id: 'termsAndConditions1',
              label: 'termsAndConditions1',
            })}
          />
          <LabeledCheckbox
            {...checkboxProps({
              id: 'termsAndConditions2',
              label: 'termsAndConditions2',
            })}
          />
          <LabeledCheckbox
            {...checkboxProps({
              id: 'termsAndConditions3',
              label: 'termsAndConditions3',
            })}
          />
        </div>

        <p className="caption">
          {T.translate('docPreviewBottomText1')} <br />
          {T.translate('docPreviewBottomText2_1')}{' '}
          <b>{T.translate('confirm')}</b>{' '}
          {T.translate('docPreviewBottomText2_2')} <br />
          {T.translate('docPreviewBottomText3')} <br />
        </p>

        <div className="row valider">
          <button className="btn" onClick={onPrevStage}>
            {T.translate('previous')}
          </button>
          <button className="btn" onClick={handleSubmit}>
            {T.translate('confirm')}
          </button>
        </div>
      </div>
      {progressBar}
    </div>
  );
};

PdfPreview.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  onPrevStage: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  paxData: PropTypes.object.isRequired,
  guardianData: PropTypes.object.isRequired,
  paxAdult: PropTypes.bool,
  allCountries: PropTypes.array.isRequired,
  progressBar: PropTypes.element.isRequired,
  paxDisplayName: PropTypes.string,
};

export default withValidation(PdfPreview);



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/PdfPreview.js